import { ErrorHandler } from '@sketch/tracing'
import {
  addProjectMembership,
  removeProjectMembership,
} from '../utils/projectMemberships.cache'
import { useProjectMembershipChangedSubscription } from '@sketch/gql-types'

export const useProjectMembershipChanged = () => {
  useProjectMembershipChangedSubscription({
    onSubscriptionData({ client, subscriptionData: { data, error, loading } }) {
      const responseData = data?.projectChanged

      if (!responseData || error || loading) {
        ErrorHandler.shouldNeverHappen(
          'Received "projectAccessChanged" subscription data should always be valid one'
        )
        return
      }

      const projectIdentifier = responseData.projectIdentifier

      // New Member is added to a project
      if (responseData.__typename === 'ProjectMemberAddedEvent') {
        addProjectMembership({
          cache: client,
          projectIdentifier,
          membership: responseData.membership,
        })
      }

      // Existing Member is removed from a project
      if (responseData.__typename === 'ProjectMemberRemovedEvent') {
        removeProjectMembership({
          cache: client,
          projectIdentifier,
          membershipIdentifier: responseData.membershipIdentifier,
        })
      }
    },
  })
}
